export default function getBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        let reader = new FileReader();
        if(file === undefined) return resolve('');
        reader.readAsDataURL(file);
        reader.onerror = reject;
        reader.onload = () => resolve(reader.result as string);
    });
}